import axios from "axios"
import api from "@/store/api"
import { monthBounds, isMonth, buildDateRangeParams } from "@/utils"

export const state = {
  devize: [],
  pagination: {
    total: 0,
    page:  1,
    limit: 10,
  },
  filters: {
    dateRange: { start: null, end: null },
    rar:       "",
    search:    "",
  },
  loading: false,
}

export const mutations = {
  SET_DEVIZE (state, payload) {
    const items = Array.isArray(payload) ? payload : payload.items || []
    state.devize = items

    if (!Array.isArray(payload)) {
      state.pagination = {
        total: +payload.total || 0,
        page:  +payload.page  || 1,
        limit: +payload.limit || 10,
      }
    }
  },

  SET_FILTER (state, { key, value }) {
    state.filters[key] = value
  },

  PATCH_MANY_DEVIZ (state, { ids, patch }) {
    const set = new Set(ids)
    state.devize = state.devize.map(d => set.has(d._id) ? { ...d, ...patch } : d)
  },

  SET_DEVIZE_LOADING (state, payload) {
    state.loading = payload
  },
}

export const actions = {
  async fetchDevize ({ state, commit }, page = 1) {
    commit("SET_DEVIZE_LOADING", true)
    try {
      const params = {
        ...buildDateRangeParams(state.filters),
        page,
        rar:    state.filters.rar    || undefined,
        search: state.filters.search || undefined,
      }

      const { data } = await axios.get(api.devize, { params })
      commit("SET_DEVIZE", data)
    } finally {
      commit("SET_DEVIZE_LOADING", false)
    }
  },

  async toggleRar ({ dispatch }, { id, rar_export }) {
    return dispatch("bulkSetRar", { ids: [id], rar_export })
  },

  async bulkSetRar ({ commit }, { ids, rar_export }) {
    if (!ids?.length) return
    try {
      await axios.post(`${api.devize}/bulk-flags`, { ids, rar_export })
      commit("PATCH_MANY_DEVIZ", { ids, patch: { rar_export } })
    } catch (err) {
      console.error("[devize] bulk toggle failed", err)
    }
  },

  setDateRange ({ commit, dispatch }, range) {
    commit("SET_FILTER", { key: "dateRange", value: range })
    dispatch("fetchDevize", 1)
  },

  setRarFilter ({ commit, dispatch }, value) {
    commit("SET_FILTER", { key: "rar", value })
    dispatch("fetchDevize", 1)
  },

  setSearch ({ commit, dispatch }, value) {
    commit("SET_FILTER", { key: "search", value })
    dispatch("fetchDevize", 1)
  },

  setPreset ({ dispatch }, preset) {
    dispatch("setDateRange", monthBounds(preset))
  },

  async downloadRaportLunar (_, { year, month }) {
    const { data } = await axios.get(api.raport_lunar_pdf, {
      params: { year, month },
      responseType: "blob",
    })
    return data
  },

  restoreFromQuery ({ commit, dispatch }, query) {
    if (query.from && query.to) {
      commit("SET_FILTER", {
        key: "dateRange",
        value: { start: new Date(query.from), end: new Date(query.to) }
      })
    }
    if (query.rar) {
      commit("SET_FILTER", { key: "rar", value: query.rar })
    }
    if (query.search) {
      commit("SET_FILTER", { key: "search", value: query.search })
    }
    dispatch("fetchDevize", Number(query.page) || 1)
  },
}

export const getters = {
  activePreset: state =>
    isMonth(state.filters.dateRange, "this") ? "this" :
      isMonth(state.filters.dateRange, "last") ? "last" : null,
}